export default "__VITE_ASSET__CY9kXToZ__"